<app-header-one [sticky]="true"></app-header-one>

<section class="small-section">
	<div class="container">
		<div class="row">
			<div class="col-md-12">
				<h2 class="section-title text-left font-alt">Terms Of Use</h2>
			</div>
		</div>
	</div>
</section>

<section class="small-section pt-0 hygiene-text text-left">
	<div class="container">
		<div class="row">
			<div class="col-md-12" [innerHtml]="terms_of_use">
			</div>
		</div>
	</div>
</section>


<app-footer-one></app-footer-one>